<template>
  <div v-if="isReady">
    <div class="bg-blue-500 text-white py-8 mb-4">
      <h2 class="mb-4 md:mb-8 text-center">{{ aboutTitle }}</h2>
      <div class="container mx-auto">
        <div class="flex flex-row items-center">
          <div class="flex-none px-4 cursor-pointer" @click="previousEvent()"><img src="/images/icon-caret-left-huge.svg"></div>
          <div class="flex-1">
            <transition name="fade" mode="out-in">
              <img :src="currentEvent.image_full_url" :alt="currentEvent.name" :key="`event-image-${currentEventIndex}`" class="mx-auto">
            </transition>
          </div>
          <div class="flex-none px-4 cursor-pointer" @click="nextEvent()"><img src="/images/icon-caret-right-huge.svg"></div>
        </div>
      </div>
    </div>

    <div class="container max-w-2xl mx-auto leading-tight mb-4 md:mb-8">
      <transition name="fade" mode="out-in">
        <div :key="`event-description-${currentEventIndex}`">
          <p class="font-bold">{{ currentEvent.year }}</p>
          <div class="text-justify" v-html="currentEvent.description"></div>
        </div>
      </transition>
    </div>

    <div class="mb-4 md:mb-8 text-center container mx-auto">
      <div
        class="inline-block mr-2 mb-2 rounded-full st-bgc h-4 w-4 cursor-pointer"
        :class="currentEventIndex == i ? 'bg-blue-300' : 'bg-blue-400 hover:bg-blue-300'"
        :key="`events-page-${i}`"
        v-for="(event, i) in events"
        @click="selectEvent(i)"></div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'about-us-history',
  props: {
    aboutTitle: {
      type: String,
      default: ''
    },
    events: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentEvent: null,
      currentEventIndex: 0,
      isReady: false,
    }
  },
  methods: {
    selectEvent(index) {
      this.currentEventIndex = index;
      this.currentEvent = this.events[this.currentEventIndex];
    },
    previousEvent() {
      if (this.currentEventIndex > 0) {
        this.currentEventIndex--;
      } else {
        this.currentEventIndex = this.events.length -1;
      }
      this.currentEvent = this.events[this.currentEventIndex];
    },
    nextEvent() {
      if (this.currentEventIndex < this.events.length -1) {
        this.currentEventIndex++;
      } else {
        this.currentEventIndex = 0;
      }
      
      this.currentEvent = this.events[this.currentEventIndex];
    },
  },
  mounted() {
    this.currentEvent = this.events[0];
    this.isReady = true;
  }
}
</script>